<template>
  <div class="store-card">
    <h3 class="gyra-h3-small-serif">
      {{ `store.${location.storeName}` | translate }}
    </h3>
    <p class="gyra-p-small-sans">
      {{ `store_map.short_descriptions.${location.storeName}` | translate }}
    </p>
    <div class="store-card-bottom-row">
      <div class="emoji-row">
        <div
          v-for="(tag, j) in location.tags"
          :key="j"
          class="emoji"
          v-b-tooltip.hover
          :title="`store_map.tooltips.${tag}` | translate"
        >
          {{ tag | emoji }}
        </div>
      </div>
      <p
        class="know-more-button know-more-button--desktop gyra-p-small-sans"
        @click="onStoreButtonClicked"
      >
        {{ `store_map.titles.know_more` | translate }}
      </p>
      <p
        class="know-more-button know-more-button--mobile gyra-p-small-sans"
        @click="onStoreButtonClicked"
      >
        {{ `store_map.titles.know_more_mobile` | translate }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "gyra-store-card",
  props: {
    location: {
      type: Object,
      required: true,
      default: null
    }
  },
  methods: {
    onStoreButtonClicked() {
      this.$emit("store-button-clicked", this.location.storeName);
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.store-card {
  width: 100%;
  padding-left: 27px;

  h3 {
    margin-top: 27px;
  }

  p {
    margin-top: 19px;
    margin-bottom: 7px;
  }
}
.store-card-bottom-row {
  margin-right: 13px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.emoji-row {
  display: flex;
  flex-direction: row;
  justify-content: left;
  width: 60%;
}
.emoji {
  font-size: 24px;

  &:not(:last-child) {
    margin-right: 20px;
  }
}

.know-more-button {
  text-decoration: underline;
  cursor: pointer;
  height: 20px;
  margin: 19px 0 0 !important;

  &--desktop {
    display: None;
    @media (min-width: 500px) {
      display: inline;
    }
  }

  &--mobile {
    display: inline;
    @media (min-width: 500px) {
      display: None;
    }
  }
}
</style>
